import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class AsSeen extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='AsSeen'>
			<div className='asSeenTitle'>As Seen In</div>
      <div className={'asSeenRow'}>
        <div className={'assRowImg imageRight'}>
          <img src='https://s3.amazonaws.com/dd-website/img/asseen/people.jpg' />
        </div>
        <div className={'assRowBox boxLeft'}>
          <div className='assBoxWrapper'>
            <div className='assBoxTitle'>People.com</div>
            <div className='assBoxButtonRow'>
              <button 
                type='button' 
                className='assBoxButton' 
                onClick={() => this.openNew('https://people.com/human-interest/wife-renews-vows-with-husband-11-years-after-bachelorette-party-accident-left-her-paralyzed/')}>See the article</button>
            </div>
          </div>
        </div>
      </div>

      <div className={'asSeenRow rightBox'}>
        <div className={'assRowImg imageLeft'}>
          <img src='https://s3.amazonaws.com/dd-website/img/asseen/nytimes.jpg' />
        </div>
        <div className={'assRowBox boxRight'}>
          <div className='assBoxWrapper'>
            <div className='assBoxTitle'>New York Times</div>
            <div className='assBoxButtonRow'>
              <button type='button' className='assBoxButton' onClick={() => this.openNew('https://www.nytimes.com/2020/05/08/fashion/weddings/the-little-wedding-on-the-deck.html')}>See the article</button>
            </div>
          </div>
        </div>
      </div>

      <div className={'asSeenRow'}>
        <div className={'assRowImg imageRight'}>
          <img src='https://s3.amazonaws.com/dd-website/img/asseen/nowweddings.jpg' />
        </div>
        <div className={'assRowBox boxLeft'}>
          <div className='assBoxWrapper'>
            <div className='assBoxTitle'>Now Weddings Magazine</div>
            <div className='assBoxSubtitle'>October 2020 Issue</div>
            <div className='assBoxButtonRow'>
              <button type='button' className='assBoxButton' onClick={() => this.internalNav('setting/SMD1426855')}>Shop similar styles</button>
              <button type='button' className='assBoxButton' onClick={() => this.openNew('https://issuu.com/nowmagazine504/docs/now_weddings_oct_2020_issue_final')}>See the article</button>
            </div>
          </div>
        </div>
      </div>

      <div className={'asSeenRow rightBox'}>
        <div className={'assRowImg imageLeft'}>
          <img src='https://s3.amazonaws.com/dd-website/img/asseen/independent.jpg' />
        </div>
        <div className={'assRowBox boxRight'}>
          <div className='assBoxWrapper'>
            <div className='assBoxTitle'>The Independent</div>
            <div className='assBoxSubtitle'>Tie the Knot Issue</div>
            <div className='assBoxButtonRow'>
              <button type='button' className='assBoxButton' onClick={() => this.internalNav('setting/SMD1444416')}>Shop similar styles</button>
              <button type='button' className='assBoxButton' onClick={() => this.openNew('https://issuu.com/kcindependent/docs/08.08.20_bridal_complete')}>See the article</button>
            </div>
          </div>
        </div>
      </div>

      <div className={'asSeenRow'}>
        <div className={'assRowImg imageRight'}>
          <img src='https://s3.amazonaws.com/dd-website/img/asseen/virginia.jpg' />
        </div>
        <div className={'assRowBox boxLeft'}>
          <div className='assBoxWrapper'>
            <div className='assBoxTitle'>Virginia Bride Magazine</div>
            <div className='assBoxSubtitle'>Spring 2021 Issue</div>
            <div className='assBoxButtonRow'>
              <button type='button' className='assBoxButton' onClick={() => this.internalNav('setting/SMD1435151')}>Shop similar styles</button>
            </div>
          </div>
        </div>
      </div>

      <div className={'asSeenRow rightBox'}>
        <div className={'assRowImg imageLeft'}>
          <img src='https://s3.amazonaws.com/dd-website/img/asseen/alabama.jpg' />
        </div>
        <div className={'assRowBox boxRight'}>
          <div className='assBoxWrapper'>
            <div className='assBoxTitle'>Alabama Weddings Magazine</div>
            <div className='assBoxSubtitle'>20th Anniversary Edition</div>
            <div className='assBoxButtonRow'>
              <button type='button' className='assBoxButton' onClick={() => this.internalNav('jewelry/PRLFE00688')}>Shop similar styles</button>
              <button type='button' className='assBoxButton' onClick={() => this.openNew('https://issuu.com/alabamaweddings/docs/aw21_issu')}>See the article</button>
            </div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default AsSeen;

function mapStateToProps(state) {
  return {

  };
}

export const AsSeenContainer = connect(
  mapStateToProps,
  allActionCreators
)(AsSeen);


// WEBPACK FOOTER //
// ./src/components/views/asseen/AsSeen.jsx